export default __webpack_public_path__ + "static/media/full logo-red-white.b8bce508.svg";